import { useMemo } from 'react'
import useOffer from 'hooks/Offers/useOffer'
import { getPackageUniqueKey } from 'lib/offer/offerUtils'
import type { CartPanelAccommodationItem } from './useCartPanelItems'

function useCartPanelHotelOfferData(item: CartPanelAccommodationItem) {
  const [offer, loading] = useOffer<App.HotelOffer>(item.offerId)

  const cartHotelItem = item.cartItem as App.MultiCartInstantBookingLEHotelItem | undefined

  const pkg = useMemo(() => {
    if (!offer || !cartHotelItem?.packageId || !cartHotelItem?.roomRateId) return undefined
    const duration = item.duration ?? cartHotelItem.duration
    const uniqueKey = getPackageUniqueKey(cartHotelItem.packageId, duration, cartHotelItem.roomRateId)
    return offer.packages.find(p => p.uniqueKey === uniqueKey)
  }, [offer, cartHotelItem, item.duration])

  return {
    offer,
    pkg,
    loading,
    checkIn: cartHotelItem?.checkIn,
    checkOut: cartHotelItem?.checkOut,
  }
}

export default useCartPanelHotelOfferData
